@file:OptIn(InternalResourceApi::class)

package manyverse.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/manyverse.shared.generated.resources/"

@delegate:ResourceContentHash(-2_035_918_703)
internal val Res.font.LibreBaskerville: FontResource by lazy {
      FontResource("font:LibreBaskerville", setOf(
        ResourceItem(setOf(), "${MD}font/LibreBaskerville.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("LibreBaskerville", Res.font.LibreBaskerville)
}
